import Carousel from "react-bootstrap/Carousel";
import React, { useEffect, useState } from "react";
import Navbar from "../Navbar/Navbar";
import { Redirect, useHistory, useParams } from "react-router";
import config from "../../config/apiConfig";
import "./StoryDetails.css";
import ch_negative from "../../icons/ch_negative.png";
import ch_positive from "../../icons/ch_positive.png";
import ch_neutral from "../../icons/ch_neutral.png";
import RingLoader from "react-spinners/RingLoader";
import negetive from "../../icons/negetive.png";
import positive from "../../icons/positive.png";
import neutral from "../../icons/neutral.png";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import {
    ExpandLess,
    ExpandMore,
    OpenInNewOutlined,
    Star,
    Visibility,
    HighlightOff,
    ArrowBack,
} from "@material-ui/icons";
import audience from "../../icons/audience.png";
import black from "../../icons/default1.png";
import imdb from "../../icons/imdb.png";
import { getNodeText } from "@testing-library/dom";
import TextUtil from "../../utils/textUtil";
import StoryCard from "../Main/StoryCard/StoryCard";
import ReactGA from "react-ga";

function StoryDetails() {
    const [story, setStory] = useState({});
    const [scrapbook, setScrapbook] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [isScrapbookLoading, setIsScrapbookLoading] = useState(true);
    const [isAddedtoScrap, setIsAddedtoScrap] = useState(false);
    const { id } = useParams("id");
    const history = useHistory();
    const [prevStoryId, setPrevStoryId] = useState("");
    const [nextStoryId, setNextStoryId] = useState("");
    const [showFull, setShowFull] = useState(false);

    useEffect(() => {
        setShowFull(false);
        const formData = new FormData();
        formData.append("session-token", Cookies.get("token"));
        formData.append("token", config.token);
        const requestOptions2 = {
            method: "POST",
            body: formData,
        };
        fetch(
            config.BASE_URL + "/v1/get/scrapbook/stories?climit=100",
            requestOptions2
        )
            .then((response) => response.json())
            .then((resp) => {
                setScrapbook(resp);
                for (var i = 0; i < resp.data.length; i++) {
                    if (resp.data[i].id == id) {
                        setIsAddedtoScrap(true);
                        break;
                    }
                    setIsAddedtoScrap(false);
                }
                console.log(scrapbook);
            })
            .catch((err) => {
                console.log(err);
            });
    }, [id]);
    useEffect(() => {
        const formData = new FormData();
        formData.append("session-token", Cookies.get("token"));
        formData.append("token", config.token);
        const requestOptions = {
            method: "POST",
            body: formData,
        };
        setIsLoading(true);
        fetch(config.BASE_URL + "/v1/get/story/" + id, requestOptions)
            .then((response) => response.json())
            .then((resp) => {
                setStory(resp);
                setIsLoading(false);
                console.log(resp);
            })
            .catch((err) => {
                console.log(err);
            });
        const storyList = JSON.parse(localStorage.getItem("story_list"));
        console.log(storyList);
        for (let i = 0; i < storyList?.length; i++) {
            if (storyList[i].id === id) {
                if (i != 0) setPrevStoryId(storyList[i - 1].id);
                else setPrevStoryId("");
                if (i != storyList.length - 1)
                    setNextStoryId(storyList[i + 1].id);
                else setNextStoryId("");
            }
        }
    }, [id]);
    function handleNoImage(e) {
        e.target.src = black;
    }
    function handleScrapbook(e, action) {
        setIsScrapbookLoading(true);
        e.preventDefault();
        const ele = document.querySelector(".scrapbook__container");
        const formData = new FormData();
        formData.append("session-token", Cookies.get("token"));
        formData.append("token", config.token);
        const requestOptions = {
            method: "POST",
            body: formData,
        };
        if (ele.style.display == "none") {
            if (action == "add") {
                ReactGA.event({
                    category: "Scrapbook",
                    action: "Add to scrapbook",
                    label: id,
                });
                fetch(
                    config.BASE_URL + "/v1/put/scrapbook/add?story_id=" + id,
                    requestOptions
                )
                    .then((response) => response.json())
                    .then((resp) => {
                        const formData = new FormData();
                        formData.append("session-token", Cookies.get("token"));
                        formData.append("token", config.token);
                        const requestOptions = {
                            method: "POST",
                            body: formData,
                        };
                        fetch(
                            config.BASE_URL +
                                "/v1/get/scrapbook/stories?climit=100",
                            requestOptions
                        )
                            .then((response) => response.json())
                            .then((resp) => {
                                setScrapbook(resp);
                                setIsScrapbookLoading(false);
                                setIsAddedtoScrap(true);
                                console.log(resp);
                            })
                            .catch((err) => console.log(err));
                        console.log(resp);
                    })
                    .catch((err) => console.log(err));
            } else {
                ReactGA.event({
                    category: "Scrapbook",
                    action: "Delete from scrapbook",
                    label: id,
                });
                fetch(
                    config.BASE_URL +
                        "/v1/put/scrapbook/delete?token=" +
                        config.token +
                        "&story_id=" +
                        id,
                    requestOptions
                )
                    .then((response) => response.json())
                    .then((resp) => {
                        const formData = new FormData();
                        formData.append("session-token", Cookies.get("token"));
                        formData.append("token", config.token);
                        const requestOptions = {
                            method: "POST",
                            body: formData,
                        };
                        fetch(
                            config.BASE_URL +
                                "/v1/get/scrapbook/stories?climit=100",
                            requestOptions
                        )
                            .then((response) => response.json())
                            .then((resp) => {
                                setScrapbook(resp);
                                setIsScrapbookLoading(false);
                                setIsAddedtoScrap(false);
                                console.log(resp);
                            })
                            .catch((err) => console.log(err));
                        console.log(resp);
                    })
                    .catch((err) => console.log(err));
            }
            ele.style.display = "block";
        } else {
            ele.style.display = "none";
        }
    }
    function handleDeleteFromScrap(story_id) {
        if (story_id === id) setIsAddedtoScrap(false);
    }
    function handleShowAns(e, id) {
        const ele = document.getElementById(id);
        if (ele.style.display === "none") {
            ele.style.display = "block";
            document.getElementById(`icon ${id}`).innerHTML =
                '<svg class="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"></path></svg>';
        } else {
            ele.style.display = "none";
            document.getElementById(`icon ${id}`).innerHTML =
                '<svg class="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"></path></svg>';
        }
    }
    function handleShowTimeline(e) {
        ReactGA.event({
            category: "Story Details",
            action: "View Timeline",
        });
        e.preventDefault();
        const ele = document.getElementById("timelineList");
        const line = document.querySelector(".tl__line");
        const list = document.querySelector("#timelineList");
        if (ele.style.display === "none") {
            ele.style.display = "block";
            line.style.display = "block";
            list.style.padding = "0 0 55px 0";
            document.querySelector("#btnText").innerHTML =
                "<p id='btnText'>Hide</p>";
            document.querySelector("#tlIcon").innerHTML =
                '<svg class="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"></path></svg>';
        } else {
            ele.style.display = "none";
            line.style.display = "none";
            list.style.padding = "0";
            document.querySelector("#btnText").innerHTML =
                "<p id='btnText'>View</p>";
            document.querySelector("#tlIcon").innerHTML =
                '<svg class="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"></path></svg>';
        }
    }

    const pixelFire = () => {
        ReactGA.event({
            category: "Story Details",
            action: "Read more",
        });
        setShowFull(true);
        const formData = new FormData();
        formData.append("session-token", Cookies.get("token") ?? "");
        formData.append("token", config.token);
        formData.append("cid", id);
        formData.append("ctype", "article");
        const requestParams = {
            method: "POST",
            body: formData,
        };
        fetch(config.BASE_URL + "/v1/put/interactions/view", requestParams);
    };

    function getScoreText(score) {
        switch (score) {
            case 0:
                return <p style={{ color: "green" }}>Low</p>;
            case 1:
                return <p style={{ color: "orange" }}>Medium</p>;
            case 2:
                return <p style={{ color: "red" }}>High</p>;
        }
    }

    function getCharacter(sentiment) {
        switch (sentiment) {
            case "positive":
                return ch_positive;
            case "negative":
                return ch_negative;
            case "nutral":
                return ch_neutral;
            default:
                return ch_neutral;
        }
    }

    function getSentimentWidget(sentiment) {
        switch (sentiment) {
            case "neutral":
                return (
                    <React.Fragment>
                        <img
                            style={{ marginRight: 8 }}
                            src={neutral}
                            alt="neutral img"
                        />
                        <span>Neutral</span>
                    </React.Fragment>
                );
            case "positive":
                return (
                    <React.Fragment>
                        <img
                            style={{ marginRight: 8 }}
                            src={positive}
                            alt="positive img"
                        />
                        <span style={{ color: "green" }}>Positive</span>
                    </React.Fragment>
                );
            case "negative":
                return (
                    <React.Fragment>
                        <img
                            style={{ marginRight: 8 }}
                            src={negetive}
                            alt="negetive img"
                        />
                        <span style={{ color: "red" }}>Negative</span>
                    </React.Fragment>
                );
        }
    }

    if (isLoading || story.data === undefined) {
        return (
            <div style={{ textAlign: "center", backgroundColor: "black" }}>
                <Navbar />
                <RingLoader color="black" loading={isLoading} />
            </div>
        );
    }

    return (
        <div className="story__container">
            <Navbar scrapbook={scrapbook} deleteScrap={handleDeleteFromScrap} />
            <div className="header__nav">
                <div className="header__left">
                    <Link className="header__p" to="/">
                        <ArrowBack fontSize="small" />
                        Go back to Discover
                    </Link>
                </div>
                <div className="header__right">
                    {isAddedtoScrap ? (
                        <button
                            className="white__btn"
                            onClick={(e) => handleScrapbook(e, "delete")}
                            style={{ width: "250px" }}
                        >
                            Delete story from Scrapbook
                        </button>
                    ) : (
                        <button
                            className="white__btn"
                            onClick={(e) => handleScrapbook(e, "add")}
                        >
                            + Add story to Scrapbook
                        </button>
                    )}

                    <Link
                        to={`/writer/story/${prevStoryId}`}
                        className={
                            prevStoryId !== ""
                                ? "head__btn"
                                : "head__btn disabled_link"
                        }
                        onClick={() =>
                            ReactGA.event({
                                category: "Story Details",
                                action: "Story navigation",
                            })
                        }
                    >
                        Previous story
                    </Link>
                    <Link
                        to={`/writer/story/${nextStoryId}`}
                        className={
                            nextStoryId !== ""
                                ? "head__btn"
                                : "head__btn disabled_link"
                        }
                        onClick={() =>
                            ReactGA.event({
                                category: "Story Details",
                                action: "Story navigation",
                            })
                        }
                    >
                        Next story
                    </Link>
                </div>
            </div>
            <div className="main__content">
                <div className="story__detail" style={{ maxWidth: "800px" }}>
                    <div className="story__timeline">
                        <div className="story__timelineTop">
                            <div>
                                <p style={{ margin: "0" }}>
                                    Published on{" "}
                                    {new Date(
                                        story.data[0].article_created_at * 1000
                                    ).toLocaleString("default", {
                                        month: "long",
                                    })}{" "}
                                    {new Date(
                                        story?.data[0]?.article_created_at *
                                            1000
                                    ).getDate()}
                                    ,{" "}
                                    {new Date(
                                        story.data[0].article_created_at * 1000
                                    ).getFullYear()}
                                </p>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <p
                                    style={{
                                        margin: "0",
                                        fontSize: "14px",
                                        color: "#7b7b7b",
                                    }}
                                >
                                    {story.data[0].story_timeline.length}{" "}
                                    related events on timeline
                                </p>
                                {story.data[0].story_timeline.length != 0 && (
                                    <button
                                        className="view__btn"
                                        onClick={handleShowTimeline}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                            }}
                                        >
                                            <p id="btnText">View</p>{" "}
                                            <div id="tlIcon">
                                                <ExpandMore />
                                            </div>
                                        </div>
                                    </button>
                                )}
                            </div>
                        </div>
                        <div className="tl__line"></div>
                        <div
                            style={{ position: "relative", display: "none" }}
                            id="timelineList"
                        >
                            {/* <div className="tl1" style={{zIndex:"2"}}></div>
                            <div style={{display:'flex'}}>
                            <div className="tc1"style={{zIndex:"2"}}></div>
                            <div className="tl__node curr__node">
                            <p>{new Date(story.data[0].article_created_at*1000).toLocaleString('default', { month: 'long' })} {new Date(story?.data[0]?.article_created_at*1000).getDate()}, {new Date(story.data[0].article_created_at*1000).getFullYear()}</p>
                            <h4>{story.data[0].title}</h4>
                            </div>
                            <div className="tl"></div>
                        </div> */}
                            <div
                                style={{
                                    height:
                                        story.data[0].story_timeline.length *
                                        105,
                                    zIndex: 1,
                                }}
                                className="tl"
                            ></div>
                            {story.data[0].story_timeline.map((st) => (
                                <div style={{ marginTop: "36px" }}>
                                    <div style={{ display: "flex" }}>
                                        <div className="tc"></div>
                                        <div
                                            onClick={(e) => {
                                                e.preventDefault();
                                                const win = window.open(
                                                    `/writer/story/${st.id}`,
                                                    "_blank"
                                                );
                                                win.focus();
                                            }}
                                            className="tl__node"
                                        >
                                            <p>
                                                {new Date(
                                                    st.article_created_at * 1000
                                                ).toLocaleString("default", {
                                                    month: "long",
                                                })}{" "}
                                                {new Date(
                                                    st.article_created_at * 1000
                                                ).getDate()}
                                                ,{" "}
                                                {new Date(
                                                    st.article_created_at * 1000
                                                ).getFullYear()}{" "}
                                            </p>
                                            {/* <p>{(new Date(st.article_created_at*1000).getDate())  (new Date(st.article_created_at*1000).getMonth()), (new Date(st.article_created_at*1000).getFullYear())}</p> */}
                                            <h4>{st.title}</h4>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <h4 className="story__header">{story?.data[0]?.title}</h4>
                    <p style={{ fontSize: "20px", lineHeight: "29px", color: '#868686' }}>
                        {story?.data[0]?.description}
                    </p>
                    {!!story?.data[0]?.images[0]?.link && (
                        <img
                            src={story?.data[0]?.images[0]?.link}
                            className="story__img"
                        />
                    )}
                    <div style={{ position: "relative" }}>
                        <div
                            style={{
                                fontSize: "20px",
                                margin: "26px 24px 24px 0px",
                                lineHeight: "33px",
                                overflow: "hidden",
                                height: showFull ? "auto" : "285px",
                            }}
                            dangerouslySetInnerHTML={{
                                __html: story?.data[0]?.body ?? "<p></p>",
                            }}
                        ></div>
                        {!showFull && (
                            <div
                                style={{
                                    position: "absolute",
                                    backgroundImage:
                                        "linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.5) 20%, #ffffff)",
                                    width: "100%",
                                    height: 152,
                                    bottom: 0,
                                    left: 0,
                                }}
                            ></div>
                        )}
                    </div>
                    {showFull ? (
                        <button
                            className="read__button"
                            onClick={(e) => {
                                e.preventDefault();
                                const win = window.open(
                                    story.data[0].url,
                                    "_blank"
                                );
                                win.focus();
                            }}
                        >
                            <OpenInNewOutlined
                                style={{
                                    fill: "#9b9b9b",
                                    marginRight: 8,
                                    width: 18,
                                }}
                            />
                            Read full article
                        </button>
                    ) : (
                        <button
                            className="read__button btn_primary"
                            onClick={pixelFire}
                        >
                            Read more
                        </button>
                    )}
                </div>
                <div className="story__info">
                    <div className="score">
                        <div
                            className="load"
                            style={{
                                borderRadius: "15px 0 0 15px",
                                zIndex: "1",
                                height: "48px",
                                position: "absolute",
                                background: "#81b524",
                                top: "0",
                                bottom: "0",
                                left: "0",
                                width: `${story.data[0].story_score * 100}%`,
                                opacity: "0.3",
                            }}
                        ></div>
                        <h4>
                            Story Score:{" "}
                            {(story.data[0].story_score * 100)
                                .toString()
                                .substr(0, 2)}
                            %
                        </h4>
                    </div>
                    <div className="social">
                        <div className="social__part">
                            <h4>
                                {TextUtil.getNumbersFormatted(
                                    story.data[0].social_media_scores_details
                                        .fb_comments
                                )}
                            </h4>
                            <p>Comments</p>
                        </div>
                        <div className="vert__line"></div>
                        <div className="social__part">
                            <h4>
                                {TextUtil.getNumbersFormatted(
                                    story.data[0].social_media_scores_details
                                        .fb_reactions
                                )}
                            </h4>
                            <p>Reactions</p>
                        </div>
                        <div className="vert__line"></div>
                        <div className="social__part">
                            <h4>
                                {TextUtil.getNumbersFormatted(
                                    story.data[0].social_media_scores_details
                                        .fb_shares
                                )}
                            </h4>
                            <p>Shares</p>
                        </div>
                    </div>
                    <div
                        className="social"
                        style={{ alignItems: "center", padding: "0 20px" }}
                    >
                        <div>
                            <h4
                                style={{
                                    fontSize: "16px",
                                    margin: "0px !important",
                                    color: "#4a4a4a",
                                }}
                            >
                                Sentiment
                            </h4>
                        </div>

                        <div>
                            <p
                                style={{
                                    margin: "0",
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                {getSentimentWidget(
                                    story.data[0].story_sentiment
                                )}
                            </p>
                        </div>
                    </div>
                    <div className="q__card" style={{ padding: 24 }}>
                        <div>
                            <div>
                                <h4
                                    style={{
                                        fontSize: "16px",
                                        margin: "0px !important",
                                        color: "#4a4a4a",
                                    }}
                                >
                                    Scores
                                </h4>
                            </div>

                            <div></div>
                        </div>
                        <div>
                            <div className="hor__line"></div>
                            <div className="scores_section">
                                <p>Relevancy</p>
                                {getScoreText(story.data[0].filters.complexity)}
                            </div>
                            <div className="scores_section">
                                <p>Uniqueness</p>
                                {getScoreText(story.data[0].filters.relevance)}
                            </div>
                            <div className="scores_section">
                                <p>Virality</p>
                                {getScoreText(story.data[0].filters.virality)}
                            </div>
                            <div className="scores_section">
                                <p>Sustenance</p>
                                {getScoreText(story.data[0].filters.sustenance)}
                            </div>
                        </div>
                    </div>
                    {story.data[0].question_answers?.map((qa) => (
                        <div className="q__card">
                            <div
                                className="q__ques"
                                onClick={(e) => handleShowAns(e, qa.ques)}
                            >
                                <h4
                                    style={{
                                        fontSize: "16px",
                                        margin: "0px !important",
                                        color: "#4a4a4a",
                                    }}
                                >
                                    {qa.ques}
                                </h4>
                                <div id={`icon ${qa.ques}`}>
                                    <ExpandMore />
                                </div>
                            </div>
                            <div
                                className="q__ans"
                                style={{ display: "none" }}
                                id={qa.ques}
                            >
                                <div className="hor__line"></div>
                                <p>{qa.answer}</p>
                            </div>
                        </div>
                    ))}
                    {/* {story.data[0].genres?.length > 0 && (
                        <div className="q__card">
                        <div className="q__ques" onClick={(e) => handleShowAns(e, "gen")}>
                        <h4 style={{fontSize:"16px", margin:"0px !important", color: "#4a4a4a"}}>Genre</h4>
                        <div id={`icon gen`}>
                        <ExpandMore/>
                        </div>
                        </div>
                        <div className="q__ans" style={{display:"none"}} id="gen">
                        <div className="hor__line"></div>
                        <div style={{display:"flex", flexWrap:'wrap'}}>
                        {story.data[0].genres?.map(gen => (
                            <p className="tag">{gen}</p>
                            ))}
                            </div>
                            </div>
                            </div>
                        )} */}
                    {/* {story.data[0].article_keywords?.length > 0 && (
                        <div className="q__card">
                        <div className="q__ques" onClick={(e) => handleShowAns(e, "ak")}>
                        <h4 style={{fontSize:"16px", margin:"0px !important", color: "#4a4a4a"}}>Article Keywords</h4>
                        <div id={`icon ak`}>
                        <ExpandMore/>
                        </div>
                        </div>
                        <div className="q__ans" style={{display:"none"}} id="ak">
                        <div className="hor__line"></div>
                        <div style={{display:"flex", flexWrap:'wrap'}}>
                        {story.data[0].article_keywords?.map(ak => (
                            <p onClick={(e) => { e.preventDefault(); const win = window.open(`/?article_keyword=${ak}`, '_blank'); win.focus(); }} className="tag">{ak}</p>
                            ))}
                            </div>
                            </div>
                            </div>
                        )} */}
                    {story.data[0].story_tags?.length > 0 && (
                        <div className="q__card">
                            <div
                                className="q__ques"
                                onClick={(e) => handleShowAns(e, "st")}
                            >
                                <h4
                                    style={{
                                        fontSize: "16px",
                                        margin: "0px !important",
                                        color: "#4a4a4a",
                                    }}
                                >
                                    Story Tags
                                </h4>
                                <div id={`icon st`}>
                                    <ExpandMore />
                                </div>
                            </div>
                            <div
                                className="q__ans"
                                style={{ display: "none" }}
                                id="st"
                            >
                                <div className="hor__line"></div>
                                <div
                                    style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                    }}
                                >
                                    {story.data[0].story_tags?.map((st) => (
                                        <p
                                            onClick={(e) => {
                                                e.preventDefault();
                                                const win = window.open(
                                                    `/writer?article_tag=${st}`,
                                                    "_blank"
                                                );
                                                win.focus();
                                            }}
                                            className="tag"
                                        >
                                            {st}
                                        </p>
                                    ))}
                                    {story.data[0].article_keywords?.map(
                                        (ak) => (
                                            <p
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    const win = window.open(
                                                        `/writer?article_keyword=${ak}`,
                                                        "_blank"
                                                    );
                                                    win.focus();
                                                }}
                                                className="tag"
                                            >
                                                {ak}
                                            </p>
                                        )
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                    {story.data[0].entities?.length > 0 && (
                        <div className="q__card">
                            <div
                                className="q__ques"
                                onClick={(e) => handleShowAns(e, "et")}
                            >
                                <h4
                                    style={{
                                        fontSize: "16px",
                                        margin: "0px !important",
                                        color: "#4a4a4a",
                                    }}
                                >
                                    Entities
                                </h4>
                                <div id={`icon et`}>
                                    <ExpandMore />
                                </div>
                            </div>
                            <div
                                className="q__ans"
                                style={{ display: "none" }}
                                id="et"
                            >
                                <div className="hor__line"></div>
                                <div
                                    style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                    }}
                                >
                                    {story.data[0].entities?.map((et) => (
                                        <p
                                            onClick={(e) => {
                                                e.preventDefault();
                                                const win = window.open(
                                                    `/writer?entity=${et.name}`,
                                                    "_blank"
                                                );
                                                win.focus();
                                            }}
                                            className="tag"
                                        >
                                            {et.name}
                                        </p>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}
                    {story.data[0].person_entities?.length > 0 && (
                        <div className="q__card">
                            <div
                                className="q__ques"
                                onClick={(e) => handleShowAns(e, "ct")}
                            >
                                <h4
                                    style={{
                                        fontSize: "16px",
                                        margin: "0px !important",
                                        color: "#4a4a4a",
                                    }}
                                >
                                    Characters
                                </h4>
                                <div id={`icon ct`}>
                                    <ExpandMore />
                                </div>
                            </div>
                            <div style={{ display: "none" }} id="ct">
                                {story.data[0].person_entities.map(
                                    (et, idx) => (
                                        <div
                                            className="character"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                const win = window.open(
                                                    `/writer?entity=${et.name}`,
                                                    "_blank"
                                                );
                                                win.focus();
                                            }}
                                        >
                                            <img
                                                src={getCharacter(et.sent_type)}
                                                alt=""
                                            />
                                            <div className="ct_title">
                                                {et.name}
                                            </div>
                                        </div>
                                    )
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {story.data[0].similar_stories.length != 0 && (
                <div className="similar__container">
                    <div
                        style={{
                            margin: "0 26px",
                            borderBottom: "solid 1px rgba(112, 112, 112, 0.2)",
                        }}
                    >
                        <h4
                            style={{
                                fontSize: "20px",
                                marginBottom: "20px !important",
                                padding: "0 0 20px 0",
                            }}
                        >
                            Similar Stories
                        </h4>
                    </div>
                    <div className="horiz__list">
                        {story?.data[0]?.similar_stories?.map(
                            (story, index) => {
                                return (
                                    <div
                                        key={index}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            const win = window.open(
                                                `/writer/story/${story.id}`,
                                                "_blank"
                                            );
                                            win.focus();
                                        }}
                                        className="story__title story__title__small"
                                    >
                                        <StoryCard
                                            index={index}
                                            image={story.images[0]?.link}
                                            score={story.story_score}
                                            id={story.id}
                                            title={story.title}
                                            isLiked={story.isLiked}
                                            isRead={story.isViewed}
                                            isAdded={story.isInScrapebook}
                                            fb_comments={
                                                story
                                                    .social_media_scores_details
                                                    ?.fb_comments
                                            }
                                            fb_shares={
                                                story
                                                    .social_media_scores_details
                                                    .fb_shares
                                            }
                                            fb_reactions={
                                                story
                                                    .social_media_scores_details
                                                    ?.fb_reactions
                                            }
                                        />
                                    </div>
                                );
                            }
                        )}
                    </div>
                </div>
            )}
            {story.data[0].similar_movies.length != 0 && (
                <div className="similar__container">
                    <div
                        style={{
                            margin: "0 26px",
                            borderBottom: "solid 1px rgba(112, 112, 112, 0.2)",
                        }}
                    >
                        <h4
                            style={{
                                fontSize: "20px",
                                marginBottom: "20px !important",
                                padding: "0 0 20px 0",
                            }}
                        >
                            Movies inspired by similar stories
                        </h4>
                    </div>
                    <div className="horiz__list">
                        {story?.data[0]?.similar_movies?.map((movie) => {
                            return (
                                <div className="movie__card">
                                    <img
                                        src={movie.poster}
                                        className="movie__poster"
                                    />
                                    <h4
                                        style={{ marginTop: "11px !important" }}
                                    >
                                        {movie.title}
                                    </h4>
                                    <p
                                        style={{
                                            fontSize: 14,
                                            margin: "8px 0",
                                        }}
                                    >
                                        <img src={imdb} width={42} alt="" />{" "}
                                        <strong>{movie.imdb_ratings}/10</strong>{" "}
                                        |{" "}
                                        <Visibility
                                            style={{ width: 18, fill: "#ccc" }}
                                        />{" "}
                                        {TextUtil.getNumbersFormatted(
                                            movie.imdb_votes
                                        )}
                                    </p>
                                    <div className="movie__btns">
                                        <a
                                            href={`https://www.imdb.com/title/${movie.imdb_id}`}
                                            target="_blank"
                                            className="visit__btn"
                                            style={{
                                                borderRadius: "5px 0 0 5px",
                                            }}
                                        >
                                            <p style={{ fontSize: "12px" }}>
                                                Visit IMDb
                                            </p>
                                        </a>
                                        <a
                                            href={`https://en.wikipedia.org/wiki/${movie.wiki_id}`}
                                            target="_blank"
                                            className="visit__btn"
                                            style={{
                                                borderRadius: "0 5px 5px 0",
                                            }}
                                        >
                                            <p style={{ fontSize: "12px" }}>
                                                Visit Wiki
                                            </p>
                                        </a>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
}

export default StoryDetails;
